import { render, staticRenderFns } from "./AccountDetailSelector.vue?vue&type=template&id=48dd9010&scoped=true&"
import script from "./AccountDetailSelector.vue?vue&type=script&lang=ts&"
export * from "./AccountDetailSelector.vue?vue&type=script&lang=ts&"
import style0 from "./AccountDetailSelector.vue?vue&type=style&index=0&id=48dd9010&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48dd9010",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
